document.addEventListener("alpine:init", () => {
  Alpine.data("mainProduct", (element, sectionID) => ({
    init() {
      this.stickyATC = false;
      this.currentVariantId = Number(element.dataset.currentVariantId);
      this.currentVariantTitle = element.dataset.currentVariantTitle;
      this.currentVariantPrice = element.dataset.currentVariantPrice;
      this.currentVariantCompareAtPrice =
        element.dataset.currentVariantCompareAtPrice;
      this.handle = element.dataset.productHandle;
      this.productGallery =
        document.querySelector("#product-gallery").innerHTML;
      this.selectedQuantity = 3;
      this.freeGiftId = Number(element.dataset.freeGiftId);
      this.totalPrice = "";
      this.productOne = {
        id: "",
        price: "",
        compareAtPrice: "",
      };
      this.productTwo = {
        id: "",
        price: "",
        compareAtPrice: "",
      };
      this.productThree = {
        id: "",
        price: "",
        compareAtPrice: "",
      };
      this.initSlider();
      this.initVideoPlay();
      this.initVideoSlider();

      // Hide gallery spinners on initial load
      this._initSpinnerHideTimeout = setTimeout(() => {
        const el = document.querySelector("#product-gallery");
        if (el) {
          el.querySelectorAll(".loading-spinner").forEach((s) => {
            s.style.display = "none";
          });
        }
        this._initSpinnerHideTimeout = null;
      }, 100);
    },

    initSlider() {
      if (window.innerWidth > 999) {
        this.thumbs = new Swiper(this.$refs.sliderThumbs, {
          slidesPerView: "auto",
          spaceBetween: 8,
          mousewheel: {
            releaseOnEdges: true,
          },
        });
      }
      this.main = new Swiper(this.$refs.sliderMain, {
        slidesPerView: "auto",
        spaceBetween: 16,
        loop: true,
        speed: 1000,
        thumbs: {
          swiper: this.thumbs,
        },
        pagination: {
          el: this.$refs.pagination,
          clickable: true,
        },
        navigation: {
          nextEl: document.querySelector(".swiper-button-prev-custom"),
          prevEl: document.querySelector(".swiper-button-next-custom"),
        },
        breakpoints: {
          1000: {
            // At width >= 1000px, disable pagination
            pagination: false,
          },
        },
      });
    },

    updateSliderImages(variantId) {
      const slides = document.querySelectorAll(".swiper-slide[variant-id]");

      slides.forEach((slide) => {
        if (Number(slide.getAttribute("variant-id")) !== variantId) {
          slide.remove();
        }
      });
    },
    async fetchGallery() {
      const productGallery = document.querySelector("#product-gallery");
      if (!productGallery) return;

      // Clear any previous hide timeout and init hide timeout
      if (this._gallerySpinnerHideTimeout != null) {
        clearTimeout(this._gallerySpinnerHideTimeout);
        this._gallerySpinnerHideTimeout = null;
      }
      if (this._initSpinnerHideTimeout != null) {
        clearTimeout(this._initSpinnerHideTimeout);
        this._initSpinnerHideTimeout = null;
      }

      const galleryHeight = productGallery.offsetHeight;
      productGallery.style.height = `${galleryHeight}px`;

      productGallery.innerHTML = this.productGallery;

      this._gallerySpinnerHideTimeout = setTimeout(() => {
        // Hide spinners first (scoped to gallery only)
        productGallery
          .querySelectorAll(".loading-spinner")
          .forEach((spinner) => {
            spinner.style.display = "none";
          });

        // Then clear height (in try/catch so hide always runs even if this throws)
        try {
          productGallery.style.height = "";
        } catch (_) {}

        this._gallerySpinnerHideTimeout = null;
      }, 2000);
    },

    updateTheThreeProducts(title) {
      const inputEls = document.querySelectorAll(
        `#but2get1 input[value="${title}"]`,
      );

      inputEls.forEach((el) => {
        el.checked = true;
        el.dispatchEvent(new Event("change", { bubbles: true }));
      });
    },

    updateSticky(title) {
      if (Alpine.store("sync").isSyncing) return;
      Alpine.store("sync").isSyncing = true;

      const stickyInput = document.querySelector(
        `#stickyATC input[value="${title}"]`,
      );

      stickyInput.checked = true;
      stickyInput.dispatchEvent(new Event("change", { bubbles: false }));

      Alpine.store("sync").isSyncing = false;
    },
    handleCheckboxChange() {
      this.updateTotalPrice();
    },

    updateTotalPrice() {
      if (this.selectedQuantity === 1) {
        this.totalPrice = this.currentVariantPrice;
      }
      if (this.selectedQuantity === 3) {
        this.totalPrice = this.productOne.price + this.productTwo.price;
      }
    },

    initVideoPlay() {
      const videoWrappers = document.querySelectorAll(".video-wrapper");
      if (!videoWrappers.length) return;

      videoWrappers.forEach(function (videoWrapper) {
        const posterImageWrapper = videoWrapper.querySelector(
          ".poster-image-wrapper",
        );
        const videoElement = videoWrapper.querySelector("video");

        if (posterImageWrapper && videoElement) {
          posterImageWrapper.addEventListener("click", function () {
            posterImageWrapper.style.display = "none";
            videoElement.play();
            videoElement.classList.remove("hidden");
          });

          videoElement.addEventListener("play", function () {
            posterImageWrapper.style.display = "none";
          });

          videoElement.addEventListener("pause", function () {
            if (videoElement.currentTime === 0 || videoElement.ended) {
              posterImageWrapper.style.display = "flex";
            }
          });
        }
      });
    },
    initVideoSlider() {
      if (!this.$refs.videoSlider) return;
      this.videoSlider = new Swiper(this.$refs.videoSlider, {
        slidesPerView: "auto",
        spaceBetween: 16,
        loop: true,
        speed: 1000,
      });

      if (!this.$refs.videoSliderDesktop) return;
      this.videoSlider = new Swiper(this.$refs.videoSliderDesktop, {
        slidesPerView: "auto",
        spaceBetween: 16,
        loop: true,
        speed: 1000,
      });
    },
  }));

  Alpine.data("productOptions", (element, handle) => ({
    init() {
      this.findMatchingVariant();
    },

    async findMatchingVariant() {
      console.log(element);

      const response = await fetch(
        window.Shopify.routes.root + `products/${handle}.js`,
      );
      const product = await response.json();

      var selectedOption = [];
      element
        .querySelectorAll('input[type="radio"]:checked')
        .forEach((radio) => {
          selectedOption.push(radio.value);
        });
      var matchedVariant = product.variants.find((variant) => {
        var pass = true;
        for (var i = 0; i < selectedOption.length; i++) {
          if (selectedOption.indexOf(variant.options[i]) === -1) {
            pass = false;
            break;
          }
        }
        return pass;
      });

      console.log(matchedVariant);

      this.currentVariantId = Number(matchedVariant.id);
      this.currentVariantTitle = matchedVariant.title;
      this.currentVariantPrice = matchedVariant.price;
      this.currentVariantCompareAtPrice = matchedVariant.compare_at_price;

      this.fetchGallery();
      // this.updateSliderImages(this.currentVariantTitle);
      this.updateSliderImages(matchedVariant.id);
      this.updateTheThreeProducts(this.currentVariantTitle);
      this.updateSticky(this.currentVariantTitle);

      setTimeout(() => {
        this.initSlider();
      }, 200);
    },
  }));

  Alpine.data("productOptionsFromProductSelector", (el, handle) => ({
    init() {},

    async findMatchingVariantFromProductSelector(selectorIndex) {
      const response = await fetch(
        window.Shopify.routes.root + `products/${handle}.js`,
      );
      const product = await response.json();

      var selectedOption = [];
      el.querySelectorAll('input[type="radio"]:checked').forEach((radio) => {
        selectedOption.push(radio.value);
      });
      var matchedVariant = product.variants.find((variant) => {
        var pass = true;
        for (var i = 0; i < selectedOption.length; i++) {
          if (selectedOption.indexOf(variant.options[i]) === -1) {
            pass = false;
            break;
          }
        }
        return pass;
      });

      if (selectorIndex === 1) {
        this.productOne.id = matchedVariant.id;
        this.productOne.price = matchedVariant.price;
        this.productOne.compareAtPrice = matchedVariant.compare_at_price;
      } else if (selectorIndex === 2) {
        this.productTwo.id = matchedVariant.id;
        this.productTwo.price = matchedVariant.price;
        this.productTwo.compareAtPrice = matchedVariant.compare_at_price;
      } else if (selectorIndex === 3) {
        this.productThree.id = matchedVariant.id;
        this.productThree.price = matchedVariant.price;
        this.productThree.compareAtPrice = matchedVariant.compare_at_price;
      }

      this.updateTotalPrice();

      console.log(matchedVariant.price);
    },
  }));

  Alpine.data("productOptionsFromSticky", (el, handle) => ({
    async handleOptionClickSticky(value) {
      if (Alpine.store("sync").isSyncing) return;

      Alpine.store("sync").isSyncing = true;

      const checkbox = document.querySelector(
        `#product_options input[value="${value}"]`,
      );
      if (checkbox) {
        checkbox.checked = true;
        checkbox.dispatchEvent(new Event("change", { bubbles: true }));
      }

      Alpine.store("sync").isSyncing = false;
    },
  }));
});
